import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SELECT_INPUT_CARET_URL } from '../constants';

// Actions
import { loadDoctorSpecialties } from '../../../../actions/doctors';

function Specialty() {
  const dispatch = useDispatch();
  const { selectedSpecialty = 0 } = useSelector(store => store.doctors);
  const [ options, setOptions ] = useState([]);

  useEffect(() => {
    loadDoctorSpecialties()
      .then((data) => {
        setOptions(data.sort((a, b) => ((a.desc > b.desc) ? 1 : -1)));
      });
  }, []);

  function handleChange(event) {
    const { value } = event.target;
    dispatch({ type: 'SET_DOCTORS_SPECIALTY', payload: value });
  }

  return (
    <>
      Specialty
      <select
        style={{
          backgroundImage: SELECT_INPUT_CARET_URL,
          paddingRight: '2rem',
        }}
        id="doctor-select-specialty-input"
        className="form-select me-3"
        onChange={handleChange}
        value={selectedSpecialty}
      >
        <option value="">All</option>
        {options.map((o) => (
          <option key={o.id} value={o.id}>
            {o.desc}
            {o.subSpecialty ? ` - ${o.subSpecialty}` : null}
          </option>
        ))}
      </select>
    </>
  );
}

export default Specialty;
